/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchFacet } from './SearchFacet';
import {
    SearchFacetFromJSON,
    SearchFacetFromJSONTyped,
    SearchFacetToJSON,
    SearchFacetToJSONTyped,
} from './SearchFacet';
import type { SolrWorkReduced } from './SolrWorkReduced';
import {
    SolrWorkReducedFromJSON,
    SolrWorkReducedFromJSONTyped,
    SolrWorkReducedToJSON,
    SolrWorkReducedToJSONTyped,
} from './SolrWorkReduced';

/**
 * 
 * @export
 * @interface SolrResultSolrWorkReduced
 */
export interface SolrResultSolrWorkReduced  {
    /**
     * 
     * @type {number}
     * @memberof SolrResultSolrWorkReduced
     */
    numberResults?: number;
    /**
     * 
     * @type {Array<SolrWorkReduced>}
     * @memberof SolrResultSolrWorkReduced
     */
    results?: Array<SolrWorkReduced>;
    /**
     * 
     * @type {Array<SearchFacet>}
     * @memberof SolrResultSolrWorkReduced
     */
    facets?: Array<SearchFacet>;
}

/**
 * Check if a given object implements the SolrResultSolrWorkReduced interface.
 */
export function instanceOfSolrResultSolrWorkReduced(value: object): value is SolrResultSolrWorkReduced {
    return true;
}

export function SolrResultSolrWorkReducedFromJSON(json: any): SolrResultSolrWorkReduced {
    return SolrResultSolrWorkReducedFromJSONTyped(json, false);
}

export function SolrResultSolrWorkReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrResultSolrWorkReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'numberResults': json['numberResults'] == null ? undefined : json['numberResults'],
              'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SolrWorkReducedFromJSON)),
              'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(SearchFacetFromJSON)),
    };
}

export function SolrResultSolrWorkReducedToJSON(json: any): SolrResultSolrWorkReduced {
    return SolrResultSolrWorkReducedToJSONTyped(json, false);
}

export function SolrResultSolrWorkReducedToJSONTyped(value?: SolrResultSolrWorkReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberResults': value['numberResults'],
        'results': value['results'] == null? value['results']: (value['results'] as Array<any>).map(SolrWorkReducedToJSON),
        'facets': value['facets'] == null? value['facets']: (value['facets'] as Array<any>).map(SearchFacetToJSON),
    };
}


